import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/atendimento/agendas${queryUrl}`)
  },
  insert(data) {
    return axios.post('/atendimento/agendas', data)
  },
  edit(data) {
    return axios.put(`/atendimento/agendas/${data.id}`, data)
  },
  delete(id) {
    return axios.put(`/atendimento/agendas/${id}`)
  },
}
